import { useState } from 'react'
import {Ship, Menu, X} from 'lucide-react'

const NAV_LINKS = [
  { label: 'Calculator', href: '#calculator' },
  { label: 'LTL Shipping', href: '#ltl' },
  { label: 'Ocean Freight', href: '#ocean' },
  { label: 'Air Freight', href: '#air' },
  { label: 'Carrier Rates', href: '#leads' },
]

function Header() {
  const [open, setOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 bg-[#1E293B] border-b border-white/10 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <a href="#top" className="flex items-center gap-2.5 group">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-[#10B981] text-white shadow-md group-hover:scale-105 transition-transform">
              <Ship className="w-5 h-5" />
            </span>
            <span className="text-white font-bold text-lg tracking-tight">
              The Freight Calculator
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="px-3 py-2 text-sm font-medium text-slate-300 hover:text-white hover:bg-white/5 rounded-md transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#calculator"
              className="ml-2 px-4 py-2 text-sm font-semibold text-white bg-[#10B981] hover:bg-[#0ea472] rounded-md transition-colors shadow-md"
            >
              Get a Quote
            </a>
          </nav>

          <button
            onClick={() => setOpen((v) => !v)}
            className="md:hidden text-slate-200 p-2 rounded-md hover:bg-white/5"
            aria-label="Toggle navigation"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open ? (
        <nav className="md:hidden border-t border-white/10 bg-[#1E293B] px-4 py-3 space-y-1">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-sm font-medium text-slate-300 hover:text-white hover:bg-white/5 rounded-md"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#calculator"
            onClick={() => setOpen(false)}
            className="block px-3 py-2 text-sm font-semibold text-center text-white bg-[#10B981] rounded-md"
          >
            Get a Quote
          </a>
        </nav>
      ) : null}
    </header>
  )
}

export default Header
